(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RaceQuestionDetailController', RaceQuestionDetailController);

    RaceQuestionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RaceQuestion', 'Race', 'QuestionAnswer'];

    function RaceQuestionDetailController($scope, $rootScope, $stateParams, previousState, entity, RaceQuestion, Race, QuestionAnswer) {
        var vm = this;

        vm.raceQuestion = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('liverunApp:raceQuestionUpdate', function(event, result) {
            vm.raceQuestion = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
